var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card__default"},[_c('h3',{staticClass:"events__title"},[_vm._v("Торги")]),_c('NewTrade'),_c('EventsTrade'),_c('UpdateTrade')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }